// Tick shown in place of the copy glyph right after a successful copy.
// currentColor so the control can turn it green without a second icon.
export const CheckSVG = ({ size = 14, ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={2.2}
    strokeLinecap="round"
    strokeLinejoin="round"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    focusable="false"
    {...props}
  >
    <path d="m5 13 4.5 4.5L19 7" />
  </svg>
)
